const ClearFieldsBtn = ({callback}) => {
    const clickEvent = ()=>{
        callback()
    }
  return (
    <button
      type="button"
      className="button-icon"
      onClick={() => clickEvent()}
      aria-label="clear"
    ></button>
  );
};
export default ClearFieldsBtn;
